import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { GatewayService } from 'projects/core/src/lib/core/GatewayService';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardOthers implements CanActivate {
  constructor(private router: Router) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    let userAuthenticated = await AppSession.userAuthenticate()

    if (userAuthenticated) {
      return true
    } else {
      // Token expirado. Realiza tentativa de novo token
      const retornoToken = await new GatewayService().requestToken()
      if (retornoToken.status == 200) {
        return true
      }
      await AppSession.clearSession()
      this.router.navigate(['']);
      return false;
    }
  }
}